import React, { useState } from 'react';
import * as S from './LFHeader.styled';
import { useAppDispatch, useAppSelector } from 'redux/hooks';
import { selectToken } from 'redux/global';
import { useHistory, useLocation } from 'react-router-dom';
import Menu from '@mui/icons-material/Menu';
import { moveSideBar } from 'pages/Navigation/utils';
import { mobileRes2 } from 'pages/styles';
import { selectHotelData, setHotelData } from 'pages/redux';
import Modal from '../Modal/Modal';
import LoggedInModal from './modals/LoggedInModal';
import { usePath } from 'pages/hooks';
import logo from 'assets/logo.png';
import { getMarketingSiteUrl } from 'utils';

export const LodgeFirstLogo = ({
  isHome,
  showText,
  onDark,
}: { isHome?: boolean; showText?: boolean; onDark?: boolean }) => (
  <S.LogoCont>
    <S.LogoImg src={logo} alt="LodgeFirst" isHome={!!isHome} onDark={!!onDark} />
    {showText && (
      <S.LogoBrandText isHome={!!isHome} onDark={!!onDark}>LodgeFirst</S.LogoBrandText>
    )}
  </S.LogoCont>
);

const LFHeader = () => {
  const [isShowLogOut, setIsShowLogOut] = useState<boolean>(false);
  const token = useAppSelector(selectToken);
  const hotelData = useAppSelector(selectHotelData);
  const dispatch = useAppDispatch();
  const history = useHistory();
  const location = useLocation();
  const { isHomePath } = usePath();
  const showAuthButtons = !token || location.pathname === '/signup';

  return (
    <>
      {
        isShowLogOut && (
          <Modal
            component={(
              <LoggedInModal
                extraFunction={() => {
                  dispatch(setHotelData(null));
                  history.push('/');
                }}
                onExit={() => {
                  setIsShowLogOut(false);
                }}
              />
            )}
            exitOnBgClick={() => setIsShowLogOut(false)}
          />
        )
      }
      <S.Container isHome={isHomePath}>
        <S.Menu>
          <S.NamePart>
            {!isHomePath && (
              <S.MenuIcon onClick={() => moveSideBar()}>
                <Menu fontSize="medium" />
              </S.MenuIcon>
            )}
            <S.HotelName
              isHome={isHomePath}
              onClick={() => {
                if (!token) {
                  window.open(getMarketingSiteUrl('/'), '_blank');
                } else {
                  if (window.innerWidth <= Number(mobileRes2.replace('px', ''))) {
                    moveSideBar();
                    return;
                  }
                  moveSideBar(true);
                  setIsShowLogOut(true);
                }
              }}
            >
              {hotelData?.name ? (
                <S.HotelNameInner>
                  <S.HotelNameText isHome={isHomePath}>{hotelData.name}</S.HotelNameText>
                  {hotelData?.branch && (
                    <S.BranchBadge isHome={isHomePath}>{hotelData.branch}</S.BranchBadge>
                  )}
                </S.HotelNameInner>
              ) : (
                <LodgeFirstLogo isHome={isHomePath} showText />
              )}
            </S.HotelName>
          </S.NamePart>

          {hotelData?.name && (
            <S.PoweredBy isHome={isHomePath}>
              <S.PoweredByLabel isHome={isHomePath}>powered by</S.PoweredByLabel>
              <LodgeFirstLogo isHome={isHomePath} showText />
            </S.PoweredBy>
          )}

          {showAuthButtons && (
            <S.SignCont>
              <S.SignInBtn onClick={() => history.push('/signin')} isHome={isHomePath}>
                Sign in
              </S.SignInBtn>
              <S.RegisterBtn onClick={() => history.push('/signup')} isHome={isHomePath}>
                Register
              </S.RegisterBtn>
            </S.SignCont>
          )}
        </S.Menu>
      </S.Container>
    </>
  );
};

export default LFHeader;
